var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.7C0 3.443 3.443 0 7.7 0C11.957 0 15.4 3.443 15.4 7.7C15.4 7.79947 15.3977 7.89976 15.3932 8.0008C14.6083 8.01254 13.8547 8.15345 13.1528 8.40324C13.1838 8.16159 13.2 7.92676 13.2 7.7C13.2 4.664 10.736 2.2 7.7 2.2C4.664 2.2 2.2 4.664 2.2 7.7C2.2 10.835 5.412 15.631 7.7 18.568C8.05781 18.114 8.43531 17.618 8.81802 17.0922C9.06533 17.8829 9.44909 18.6132 9.94173 19.2557C8.6805 20.9144 7.7 22 7.7 22C7.7 22 0 13.475 0 7.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5132 22C19.3796 22 22.5132 18.8664 22.5132 15C22.5132 11.1336 19.3796 8 15.5132 8C11.6468 8 8.51318 11.1336 8.51318 15C8.51318 18.8664 11.6468 22 15.5132 22ZM18.603 13.7148L15.103 17.2148C14.846 17.4719 14.4304 17.4719 14.1761 17.2148L12.4261 15.4648C12.169 15.2078 12.169 14.7922 12.4261 14.5379C12.6831 14.2836 13.0987 14.2809 13.353 14.5379L14.6382 15.823L17.6733 12.7852C17.9304 12.5281 18.346 12.5281 18.6003 12.7852C18.8546 13.0422 18.8573 13.4578 18.6003 13.7121L18.603 13.7148Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68 9.9C9.06071 9.9 10.18 8.78071 10.18 7.4C10.18 6.01929 9.06071 4.9 7.68 4.9C6.29929 4.9 5.18 6.01929 5.18 7.4C5.18 8.78071 6.29929 9.9 7.68 9.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTick);
export default __webpack_public_path__ + "static/media/locationTick.1ada2014faf82e48847911f4ceabc65b.svg";
export { ForwardRef as ReactComponent };